// extracted by css-extract-rspack-plugin
export default {"menu":"menu-eX2sXJ","subTrigger":"subTrigger-kn9LfD","subMenu":"subMenu-MSX5f6"};